import { Route, Routes, BrowserRouter } from "react-router-dom";
import { Suspense, lazy } from "react";
import Layout from "../pages/Layout";

const RadarPage = lazy(() => import("../pages/Radar/RadarPage"));
const SatellitePage = lazy(() => import("../pages/Satellite/SatellitePage"));
const StationsPage = lazy(() => import("../pages/Stations/StationsPage"));
const WrfPage = lazy(() => import("../pages/Wrf/WrfPage"));
const AboutPage = lazy(() => import("../pages/About/AboutPage"));
const BoletinsPage = lazy(() => import("../pages/Boletins/BoletinsPage"));

const Fallback = () => (
  <div className="loader-wrapper">
    <img src="/liao_loader.gif" alt="Carregando" className="loader-image" />
  </div>
);

export const Root: React.FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Fallback />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<RadarPage />} />
            <Route path="/satelite" element={<SatellitePage />} />
            <Route path="/estacoes" element={<StationsPage />} />
            <Route path="/wrf" element={<WrfPage />} />
            <Route path="/sobre" element={<AboutPage />} />
            <Route path="/boletins" element={<BoletinsPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
